import React from 'react';
import {
  FaSearch,
} from "react-icons/fa"; //Font Awesome 5
import {
  Button,
  Form,
  Input,
  DatePicker,
  Select,
  Row,
  Col,
  Typography,
  Table,
  Skeleton,
  Result,
  Tag,
} from 'antd';
import { useQuery } from '@tanstack/react-query';
import { useLocation, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';

const attendanceStatus = [
  { label: 'attend', value: true },
  { label: 'absent', value: false },
]
const columns = [
  {
    title: 'Date',
    dataIndex: 'attendance',
    key: 'attendance',
    render: (text, _) => dayjs(text.check_date).format('DD-MM-YYYY')
    // render: (text, record) =>
    //   <Button
    //     type='text'
    //     href={`/admin/attendance/${record._id}`}
    //     style={{
    //       width: "100%",
    //       background: 'none',
    //       textAlign: 'left'
    //     }}>
    //     {dayjs(text).format('DD-MM-YYYY')}
    //   </Button>
  },
  {
    title: 'Time',
    dataIndex: 'attendance',
    key: 'attendance',
    render: (text, _) => `${text.begin_time} - ${text.end_time}`
  },
  {
    title: 'Course',
    dataIndex: 'attendance',
    key: 'attendance',
    render: (text, _) => text.product.name
  },
  {
    title: 'Name',
    dataIndex: 'student',
    key: 'student',
    render: (text, _) => `${text.fname_th} ${text.lname_th}`
  },
  {
    title: 'Nicknanme',
    dataIndex: 'student',
    key: 'student',
    render: (text, _) => text.nick_name ?? "-"
  },
  {
    title: 'Status',
    dataIndex: 'is_attent',
    key: 'is_attent',
    render: (text, _) => text ? <Tag color="green" style={{ borderRadius: '20px' }}>attend</Tag> : <Tag color="red" style={{ borderRadius: '20px' }}>absent</Tag>
  }
]

function AttendanceSearch() {
  const redirect = useNavigate();
  const [form] = Form.useForm();
  const location = useLocation();
  const check_date = new URLSearchParams(location.search).get('check_date');
  const course = new URLSearchParams(location.search).get('course');
  const status = new URLSearchParams(location.search).get('status');
  const q = new URLSearchParams(location.search).get('q');

  let apiText = `/api/attendance/getAttendanceBySearch?${window.location.href.split("?")[1]}`;

  const activeCourseQuery = useQuery({ queryKey: ['/api/attendance/getActiveCourse'] })
  const { isError, isLoading, data, error } = useQuery({
    queryKey: [apiText],
  })

  if (isLoading || activeCourseQuery.isLoading) {
    return <Skeleton active />
  }

  if (isError || activeCourseQuery.isError) {
    return <Result status="error" title={error.message || activeCourseQuery.error.message} />
  };

  const onSearch = () => {

    form
      .validateFields()
      .then(values => {
        // console.log(values);
        let searchText = ""
        if (!!values.check_date) {
          searchText += `check_date=${dayjs(values.check_date).toISOString()}&`
        }
        if (!!values.course) {
          searchText += `course=${values.course}&`
        }
        if (!!values.q) {
          searchText += `q=${values.q}`
        }
        if (!!values.status || values.status !== null) {
          searchText += `status=${values.status}`
        }

        redirect(`/admin/attendance/search?${searchText}`)
      })
      .catch(err => {
        console.log(err)
      })

  }

  // console.log('data = ', data)
  return (
    <div >
      <Row gutter={[16, 16]}>
        <Col xs={24}>
          <Row >
            <Col>
              <Typography.Title level={3}>
                Search Attendance
              </Typography.Title>
            </Col>
          </Row>
        </Col>
        <Col xs={24}>
          <Form
            form={form}
            name='searchOrders'
            initialValues={{
              ...(check_date && { check_date: dayjs(check_date) }),
              course,
              status:Boolean(status === 'true'),
              q
            }}
          >
            <Row justify='space-between' gutter={[8, 0]}>
              <Col xs={24} md={6}>
                <Form.Item
                  label=""
                  name="check_date"
                >
                  <DatePicker style={{ width: "100%" }} format={'DD-MM-YYYY'} />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  label=""
                  name="course"
                >
                  <Select
                    placeholder="Select Course"
                    showSearch
                    optionFilterProp="children"
                    allowClear
                  >
                    {
                      activeCourseQuery.data.map(course => <Select.Option key={course._id} value={course._id}>{course.name}</Select.Option>)
                    }
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} md={6}>
                <Form.Item
                  label=""
                  name="status"
                >
                  <Select
                    placeholder="Status"
                    showSearch
                    optionFilterProp="children"
                    allowClear
                  >
                    {
                      attendanceStatus.map(st => <Select.Option key={st.label} value={st.value}>{st.label}</Select.Option>)
                    }
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[8, 0]}>
              <Col flex={1} >
                <Form.Item label="" name="q">
                  <Input placeholder="Search Student name, Student ID or Phone" />
                </Form.Item>
              </Col>
              <Col>
                <Button
                  type='primary'
                  icon={<FaSearch />}
                  onClick={onSearch}
                  style={{ width: '100%' }}
                >Search</Button>
              </Col>
            </Row>
          </Form>
        </Col>
        <Col xs={24}>
          <Table
            rowKey={(record) => record._id}
            columns={columns}
            dataSource={data}
            scroll={{
              x: 1200,
            }}
          />
        </Col>
      </Row>
    </div>
  )
}

export default AttendanceSearch